import { render } from "./DataProportionChart.vue?vue&type=template&id=52d271b8&ts=true"
import script from "./DataProportionChart.vue?vue&type=script&lang=ts"
export * from "./DataProportionChart.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__